// Import api models.
import {
	BindingAuthorityEligibilityResult,
	NewBusinessApplication,
	NewBusinessApplicationDocument,
	PossibleDisclosureText,
	PossiblePeril,
} from '@app/models/api';

interface NewBusinessApplicationState {
	areBindingAuthorityEligibilityResultsLoaded: boolean;
	isNewBusinessApplicationLoaded: boolean;
	areNewBusinessPossiblePerilsLoaded: boolean;
	newBusinessApplication?: NewBusinessApplication;
	newBusinessApplicationDocument?: NewBusinessApplicationDocument;
	selectedBuildingGuid?: string;
	selectedMortgageeGuid?: string;
	possibleDisclosureTexts: PossibleDisclosureText[];
	bindingAuthorityEligibilityResults: BindingAuthorityEligibilityResult[];
	newBusinessPossiblePerils: PossiblePeril[];
};

const getInitialState = (): NewBusinessApplicationState => {
	return {
		areBindingAuthorityEligibilityResultsLoaded: false,
		isNewBusinessApplicationLoaded: false,
		areNewBusinessPossiblePerilsLoaded: false,
		newBusinessApplication: undefined,
		newBusinessApplicationDocument: undefined,
		selectedBuildingGuid: undefined,
		selectedMortgageeGuid: undefined,
		possibleDisclosureTexts: [],
		bindingAuthorityEligibilityResults: [],
		newBusinessPossiblePerils: [],
	};
};

export { getInitialState, NewBusinessApplicationState };